// The "Featured" pick shared by the homepage bento grid and the search
// dropdown's Suggested list: listings flagged is_featured first, topped up with
// the highest-priced cards. Only listings with a cert image qualify.

const API = process.env.REACT_APP_API_BASE_URL;

const hasImage = (l) => !!l?.cert?.cert_images?.front_image_url;

export const pickFeatured = (listings, n = 8) => {
    const all = listings || [];
    const flagged = all.filter((l) => l.is_featured && hasImage(l));
    const byPrice = all
        .filter((l) => hasImage(l) && !l.is_featured)
        .sort((a, b) => (Number(b.price) || 0) - (Number(a.price) || 0));
    return [...flagged, ...byPrice].slice(0, n);
};

// One fetch per page load, shared by every caller, and only made on demand
// (the search box asks for it the first time someone focuses it).
let featuredPromise = null;

export const loadFeatured = (n = 8) => {
    if (!featuredPromise) {
        featuredPromise = fetch(`${API}/listings?count=500`)
            .then((res) => (res.ok ? res.json() : { listings: [] }))
            .then((data) => data.listings || [])
            .catch(() => {
                featuredPromise = null; // let the next focus retry
                return [];
            });
    }
    return featuredPromise.then((listings) => pickFeatured(listings, n));
};
